import { Currency } from './currency';

export enum Countries {
  SWEDEN = 'SWEDEN',
  FINLAND = 'FINLAND',
}

export enum Languages {
  SWEDEN = 'SWEDEN',
  FINLAND = 'FINLAND',
  ENGLAND = 'ENGLAND',
}

export const CountryLanguageShort = {
  [Languages.SWEDEN]: 'sv',
  [Languages.FINLAND]: 'fi',
  [Languages.ENGLAND]: 'en',
};

export const CountryShort = {
  [Countries.SWEDEN]: 'sv-SE',
  [Countries.FINLAND]: 'fi-FI',
};
export const CountryCurrency = {
  [Countries.SWEDEN]: Currency.SEK,
  [CountryShort.SWEDEN]: Currency.SEK,
  [Countries.FINLAND]: Currency.EUR,
  [CountryShort.FINLAND]: Currency.EUR,
};

export const getCountryShortFromCurrency = (currency: Currency): string | undefined => {
  const entry = Object.entries(CountryCurrency).find(([, value]) => value === currency);

  return entry ? CountryShort[entry[0] as keyof typeof CountryShort] : undefined;
};
